import React, { useState } from 'react';

import { FormControl, FormHelperText, Checkbox } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  left: {
    textAlign: 'left',
  },
  popOver: {
    background: '#FFFFFF',
    border: '1px solid #E7E7E7',
    borderRadius: '5px',
    boxShadow: '2px 6px 10px rgba(0, 0, 0, 0.1)',
    boxSizing: 'border-box',
  },
}));

const SelectField = ({ value, className, onChange, items, helperText, FormHelperTextProps, placeholder, multiple, renderValue, disabled }) => {
  const classes = useStyles();
  const [changed, setChanged] = useState(false);

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    setChanged(true);
    onChange(selectedValue);
  };

  const menuItems = items.map((item) => {
    if (multiple) {
      return (
        <MenuItem key={item.value} value={item.value}>
          <Checkbox checked={Array.isArray(value) && value.indexOf(item.value) > -1} />
          {item.label}
        </MenuItem>
      );
    }

    return (
      <MenuItem key={item.value} value={item.value}>
        {item.label}
      </MenuItem>
    );
  });

  return (
    <FormControl fullWidth>
      <Select
        labelId="select-label"
        id="select"
        fullWidth
        disabled={disabled}
        multiple={multiple || false}
        value={multiple ? value || [] : value || ''}
        onChange={handleChange}
        className={`${classes.left} ${className}`}
        displayEmpty
        renderValue={renderValue || undefined}
        MenuProps={{
          PopoverClasses: {
            paper: classes.popOver,
          },
        }}>
        {placeholder && !changed && !multiple ? (
          <MenuItem value="">
            <em>{placeholder}</em>
          </MenuItem>
        ) : null}
        {menuItems}
      </Select>
      {helperText && (
        <FormHelperText {...FormHelperTextProps} error>
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default SelectField;
